import type * as React from 'react';

import { useMetaConfig } from '@xing-com/hub';
import { MetaRenderer } from '@xing-com/meta-renderer';
import { commonMetaRendererResolvers } from '@xing-com/platform-layout-common-meta-renderer-resolvers';

import { SearchDropdownItem } from './search-dropdown-item';

const settingsDropdownResolvers = {
  SearchDropdownItem,
};

const resolvers = {
  ...commonMetaRendererResolvers,
  ...settingsDropdownResolvers,
};

export const SearchDropdownList: React.FC<{
  closeModal: () => void;
}> = ({ closeModal }) => {
  const { data } = useMetaConfig();

  return data?.navigation?.searchDropdown ? (
    <MetaRenderer
      config={data.navigation.searchDropdown}
      resolvers={resolvers}
      closeModal={closeModal}
    />
  ) : null;
};
